import AgingDiscountedProductsPage from 'components/distributionSetting/agingProducts'
import CommonLayout from 'layouts/DashboardLayout'
import React from 'react'

const AgingDiscountedProducts = () => {
    return (
        <CommonLayout>
            <AgingDiscountedProductsPage />
        </CommonLayout>
    )
}

export default AgingDiscountedProducts
